export const toStringGoogle = (boolean, t) => {
  return boolean ? t("global.yes") : t("global.no");
};

export const transformProxyType = proxyType => {
  switch (proxyType) {
    case "NOTANONYMOUS":
      return "-";
    case "DISTORTING":
      return "Anonymous";
    default:
      if (!proxyType || typeof proxyType !== "string") {
        return "Unspecified";
      }
      return (
        proxyType.charAt(0).toUpperCase() + proxyType.slice(1).toLowerCase()
      );
  }
};

export const formatTime = (milliseconds, t) => {
  if (milliseconds == null || isNaN(milliseconds)) {
    return `-`;
  }
  const seconds = Math.floor(milliseconds / 1000);

  if (seconds > 59) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} ${t("global.min")}`;
  } else {
    return `${seconds} ${t("global.sec")}`;
  }
};
